module.exports = __webpack_public_path__ + "media/images/patins-c1f5c0494c55eae40b5c298c798efef4.png";